import React, { useState } from "react";

import { ChevronDown, ChevronRight, CheckCircle2, Clock3 } from "lucide-react";
import { formatDateTime } from "../../helpers/formatDateTime";
import { toast } from "react-toastify";

const ChecklistItemRow = ({ item, clientId, onUpdate }) => {
  const [expanded, setExpanded] = useState(false);

  const [remarks, setRemarks] = useState("");

  // const [attachmentLink, setAttachmentLink] = useState("");

  const [loading, setLoading] = useState(false);

  const handleToggle = async (received) => {
     if (!remarks?.trim()) {
      toast.error("Remarks is required");
      return;
    }
    try {
      setLoading(true);

      await onUpdate({
        clientId,
        checklistCode: item.checklistCode,
        received,
        remarks,
        // attachmentLink,
      });
      setRemarks("");
      // setAttachmentLink("");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="border border-gray-200 rounded-xl overflow-hidden bg-white">
      {/* Row */}
      <div
        onClick={() => setExpanded(!expanded)}
        className="cursor-pointer px-4 py-3 hover:bg-gray-50 transition"
      >
        <div className="flex items-center justify-between gap-3">
          <div className="flex items-start gap-3 flex-1 min-w-0">
            <button
              type="button"
              // disabled={loading}
              // onClick={(e) => {
              //   e.stopPropagation();
              //   handleToggle(!item.received);
              // }}
              className="flex-shrink-0"
            >
              {loading ? (
                <div className="h-5 w-5 border-2 border-gray-300 border-t-red-500 rounded-full animate-spin" />
              ) : item.received ? (
                <CheckCircle2
                  size={22}
                  className="text-green-600 cursor-pointer hover:scale-110 transition"
                />
              ) : (
                <Clock3
                  size={22}
                  className="text-orange-500 cursor-pointer hover:scale-110 transition"
                />
              )}
            </button>

            <div className="min-w-0">
              <p className="font-medium text-gray-800 break-words">
                {item.checklistTitle}
              </p>

              {item.remarks && (
                <p className="text-xs text-gray-500 mt-1 truncate">
                  Remarks: {item.remarks}
                </p>
              )}
              {item.attachmentLink && (
                <a
                  href={item.attachmentLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-xs text-blue-600 hover:underline block mt-1"
                >
                  View Attachment
                </a>
              )}
            </div>
          </div>

          <div className="flex items-center gap-3 flex-shrink-0">
            <span
              className={`px-2 py-1 rounded-full text-xs font-medium ${
                item.received
                  ? "bg-green-100 text-green-700"
                  : "bg-orange-100 text-orange-700"
              }`}
            >
              {item.received ? "Completed" : "Pending"}
            </span>

            {expanded ? <ChevronDown size={18} /> : <ChevronRight size={18} />}
          </div>
        </div>
      </div>

      {/* Expanded */}
      {expanded && (
        <div className="border-t bg-gray-50 p-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Remarks
              <span className="text-gray-400 font-normal"> (Must)</span>
            </label>

            <textarea
              rows={3}
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
              placeholder="Enter remarks..."
              className={`w-full rounded-lg p-3 text-sm resize-none focus:outline-none focus:ring-2 ${
                !remarks?.trim()
                  ? "border-red-300 focus:ring-red-500"
                  : "border-gray-300 focus:ring-green-500"
              }`}
            />
          </div>
          {/* <div className="mt-3">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Attachment Link
            </label>

            <input
              type="url"
              value={attachmentLink}
              onChange={(e) => setAttachmentLink(e.target.value)}
              placeholder="https://drive.google.com/..."
              className="w-full border border-gray-300 rounded-lg p-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div> */}
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mt-4">
            {item.completedAt && (
              <div className="text-xs text-gray-500">
                Completed On : {formatDateTime(item.completedAt)}
              </div>
            )}

            <div>
              {item.received ? (
                <button
                  disabled={loading || !remarks?.trim()}
                  onClick={() => handleToggle(false)}
                  className={`px-4 py-2 w-full md:w-auto rounded-lg text-white text-sm ${
                    loading || !remarks?.trim()
                      ? "bg-gray-400 cursor-not-allowed"
                      : " bg-orange-500 hover:bg-orange-600"
                  }`}
                >
                  Mark Pending
                </button>
              ) : (
              <button
                disabled={loading || !remarks?.trim()}
                onClick={() => handleToggle(true)}
                className={`px-4 py-2 w-full md:w-auto rounded-lg text-white text-sm ${
                  loading || !remarks?.trim()
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-green-600 hover:bg-green-700"
                }`}
              >
                Mark Complete
              </button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChecklistItemRow;
